var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
var ColGroup = /** @class */ (function (_super) {
    __extends(ColGroup, _super);
    function ColGroup(props) {
        return _super.call(this, props) || this;
    }
    ColGroup.prototype.render = function () {
        var _a = this.props, columns = _a.columns, fixed = _a.fixed;
        var table = this.context.table;
        var leafColumns;
        if (fixed === 'left') {
            leafColumns = table.columnManager.leftLeafColumns();
        }
        else if (fixed === 'right') {
            leafColumns = table.columnManager.rightLeafColumns();
        }
        else {
            leafColumns = table.columnManager.leafColumns();
        }
        return (React.createElement("colgroup", null, leafColumns.map(function (column, colIndex) {
            return React.createElement("col", { key: colIndex, style: { width: column.width } });
        })));
    };
    ColGroup.contextTypes = {
        table: PropTypes.any,
    };
    return ColGroup;
}(Component));
export { ColGroup };
